import { AxiosResponse } from 'axios';
import { RestServiceConnection } from '../restServiceConnection';

const ENDPOINT = '/client';

export class ClientService extends RestServiceConnection {

    //--------------------------------------------------------------------------------------------------------
    /**
     * @ES LISTAR CLIENTES
     * @EN LIST CLIENTS
     * 
     * @param filters
     */
    //--------------------------------------------------------------------------------------------------------
    listClients = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }
    //--------------------------------------------------------------------------------------------------------

    //--------------------------------------------------------------------------------------------------------
    /**
     * @ES LISTAR CLIENTES PARA LOS SELECTORES
     * @EN LIST CLIENTS FOR SELECTORS
     * 
     * @param filters
     */
    //--------------------------------------------------------------------------------------------------------
    listClientsForSelect = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-for-select',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }
    //--------------------------------------------------------------------------------------------------------


    //--------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTENER CLIENTE POR ID
     * @EN GET CLIENT BY ID
     * 
     * @param clientId
     */
    //--------------------------------------------------------------------------------------------------------
    getClientById = async (clientId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/get',
            data: { 
                id: clientId
            },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    //--------------------------------------------------------------------------------------------------------

    //--------------------------------------------------------------------------------------------------------
    /**
     * @ES CAMBIAR ESTADO DE CLIENTE
     * @EN TOGGLE CLIENT STATE
     * 
     * @param clientId
     * @param status
     */
    //--------------------------------------------------------------------------------------------------------
    toggleClientState = async (clientId: string, status: boolean) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/toggle',
            data: 
            { 
                id: clientId, 
                active: status
             },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    //--------------------------------------------------------------------------------------------------------


    //--------------------------------------------------------------------------------------------------------
    /**
     * @ES CREAR CLIENTE
     * @EN CREATE CLIENT
     * 
     * @param entity
     * @returns
     */
    //--------------------------------------------------------------------------------------------------------
    createClient = async (entity: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/create',
            data: entity,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    //--------------------------------------------------------------------------------------------------------


    //--------------------------------------------------------------------------------------------------------
    /**
     * @ES EDITAR CLIENTE
     * @EN EDIT CLIENT
     * 
     * @param entity
     */
    //--------------------------------------------------------------------------------------------------------
    editClient = async (entity: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/edit',
            data: entity,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    //--------------------------------------------------------------------------------------------------------


    //--------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINAR CLIENTE
     * @EN DELETE CLIENT
     * 
     * @param clientId
     */
    //--------------------------------------------------------------------------------------------------------
    deleteClient = async (clientId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete',
            data: { 
                id: clientId
             },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    //--------------------------------------------------------------------------------------------------------


    //--------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINAR MULTIPLES CLIENTES
     * @EN DELETE MULTIPLE CLIENTS
     * 
     * @param clientIds
     */
    //--------------------------------------------------------------------------------------------------------
    deleteMultiClients = async (clientIds: string[]) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete-multi',
            data: { clientIds },
        }, true);
        return this;
    }
    //--------------------------------------------------------------------------------------------------------


    //--------------------------------------------------------------------------------------------------------
    /**
     * @ES AGREGAR PARQUES A CLIENTE
     * @EN ADD PARKS TO CLIENT
     * 
     * @param id
     * @param parks
     */
    //--------------------------------------------------------------------------------------------------------
    addParksToClient = async (id:string, parks: string[]) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/add-parks-to-client',
            data: { 
                id: id,
                parks: parks
            },
        }, true);
        return this;
    }
    //--------------------------------------------------------------------------------------------------------


    

}